export const APPROVAL_FLOW_VERSION_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  RETIRED: 'RETIRED',
} as const;

export const APPROVAL_NODE_TYPE = {
  APPLICANT_MANAGER: 'APPLICANT_MANAGER',
  ORG_ROLE: 'ORG_ROLE',
  FIXED_USER: 'FIXED_USER',
} as const;

export const APPROVAL_MODE = { ANY_ONE: 'ANY_ONE', ALL: 'ALL' } as const;

export const APPROVAL_INSTANCE_STATUS = {
  RUNNING: 'RUNNING',
  APPROVED: 'APPROVED',
  RETURNED: 'RETURNED',
  REJECTED: 'REJECTED',
  WITHDRAWN: 'WITHDRAWN',
  CANCELLED: 'CANCELLED',
} as const;

export const APPROVAL_TASK_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  RETURNED: 'RETURNED',
  REJECTED: 'REJECTED',
  SKIPPED: 'SKIPPED',
  CANCELLED: 'CANCELLED',
} as const;

export const APPROVAL_ACTION = {
  APPROVE: 'APPROVE',
  RETURN: 'RETURN',
  REJECT: 'REJECT',
  WITHDRAW: 'WITHDRAW',
  TRANSFER: 'TRANSFER',
  URGE: 'URGE',
} as const;

export type ApprovalNodeType = (typeof APPROVAL_NODE_TYPE)[keyof typeof APPROVAL_NODE_TYPE];
export type ApprovalMode = (typeof APPROVAL_MODE)[keyof typeof APPROVAL_MODE];
